export default {
    parts: [],
    baseStyle: (props) => ({
        featuresLinksContainer: {
            display: { lg: 'flex' },
            justifyContent: { lg: 'space-around' },
            maxWidth: { lg: 'container.xxxl' },
            paddingTop: { base: 6, lg: 8 },
            paddingRight: { base: 4, lg: 6 },
            paddingBottom: { base: 6, lg: 8 },
            paddingLeft: { base: 4, lg: 6 },
            marginTop: { base: 6, lg: 16 },
            marginBottom: { base: 6, lg: 16 },
            marginLeft: { lg: 'auto' },
            marginRight: { lg: 'auto' }
        }
    })
}
